import styled from 'styled-components';

export const ProductsEditCategoriesStyled = styled.div`
  width: 370px;
`;
